<template>
  <div class="change-evn">
    <slot name="txtBefore"></slot>
    <b-form-group>
      <b-form-radio-group name="evnSelection" class="rows" v-model="evnSelected_" @change="$v.evnSelected_.$touch()">
        <b-form-radio
          :key="evn.key"
          :value=evn.key
          class="allEvnSelection"
          plain
          :id="'evnSelection_' + evn.key"
          v-for="evn in allEvn"
          ><slot :name="`${evn.key + 'Label'}`"></slot> <slot :name="`${evn.key + 'Note'}`"></slot>
        </b-form-radio>
      </b-form-radio-group>
    </b-form-group>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import syncProperty from '@/mixins/syncProperty'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'EvnSelect',
  props: {
    plainRadio: {
      type: Boolean,
      default: false
    }
  },
  mixins: [
    validationMixin,
    syncProperty('evnSelected', 'evnSelected_'),
    syncProperty('evnChanged', 'evnChanged_')
  ],
  watch: {
    '$v.$dirty': function () {
      this.evnChanged_ = this.$v.$dirty
    }
  },
  computed: {
    allEvn: function () {
      return [
        { key: 'NOT' },
        { key: 'ANO' },
        { key: 'ALL' }
      ]
    }
  },
  validations () {
    return {
      evnSelected_: {
        required
      }
    }
  }
}
</script>
